import styled from 'styled-components';

export const Container = styled.header`
  margin-bottom: 60px;
`;
